import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=345064fc&"
import script from "./Radio.vue?vue&type=script&lang=js&"
export * from "./Radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Radio.vue?vue&type=custom&index=0&blockType=XXXstyle&scope=true"
if (typeof block0 === 'function') block0(component)

export default component.exports